<template>
    <footer class="navigation-footer">
        <div class="navigation-footer__container">
            <div class="navigation-footer__item" id="support">
                <span @mouseenter="show" @mouseleave="hide">
                    Тех. поддержка
                </span>
            </div>

            <Teleport to="body">
                <Transition name="fade">
                    <div v-if="showTooltip" class="navigation-footer__tooltip" :style="tooltipStyle">
                        <span class="working-hours">Будни, с 9:00 до 18:00</span>
                        <a href="tel:+74951463030">+7 (495) 146-30-30</a>
                        <a href="tel:+88005558322">8 (800) 555-83-22</a>
                        <a href="mailto:support@d-services.ru">support@d-services.ru</a>
                    </div>
                </Transition>
            </Teleport>

            <div class="navigation-footer__item">
                <a :href="documentation_path">Документация</a>
            </div>

            <div class="navigation-footer__copyright">©
                <span>{{ new Date().getFullYear() }}. ООО «Цифровые Сервисы». Все права защищены</span>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "NavigationFooterComponent",

    props: {
        documentation_path: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            showTooltip: false,
            tooltipStyle: {}
        }
    },

    methods: {
        show(e) {
            const rect = e.currentTarget.getBoundingClientRect();

            this.tooltipStyle = {
                position: 'fixed',
                top: `${rect.top + rect.height / 2}px`,
                left: `${rect.right + 12}px`,
                transform: 'translateY(-50%)',
                zIndex: 9999
            };

            this.showTooltip = true;
        },

        hide() {
            this.showTooltip = false;
        }
    }
}
</script>
